import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyPipe } from '../pages/currency.pipe';
import { OrderbyPipe } from '../pages/orderby.pipe';
import { SafeHtmlPipe } from '../pages/safe-html.pipe';
import { SearchPipePipe } from '../pages/search-pipe.pipe';
import { DateLabelPipe } from '../pages/date-label.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    CurrencyPipe,
    OrderbyPipe,
    SafeHtmlPipe,
    SearchPipePipe,
    DateLabelPipe
  ],
  exports: [
    CurrencyPipe,
    OrderbyPipe,
    SafeHtmlPipe,
    SearchPipePipe,
    DateLabelPipe
  ],
  
})
export class PipeModule { }